(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54666],{

/***/ 78573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/aisoSettings/payInfo",
      function () {
        return __webpack_require__(67820);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageTokenCheck; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var function_LogOut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39222);




/* 회원 비회원 token 값 체크 */ var PageTokenCheck = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(settings, router) {
        var tokenValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            if (tokenValue === "" || tokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
                // window.localStorage.removeItem("aisoToken");
                router.push("/user/market");
                ;
            } else {
                /* 만료된 토큰인지 체크해야함 */ // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch", function(error, decoded) {
                    ;
                    if (error) {
                        /* 만료된 토큰임. token 삭제하기 */ // window.localStorage.removeItem("aisoToken");
                        (0,function_LogOut__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(settings);
                        router.push("/user/market");
                    } else {
                        var email = decoded.email, name = decoded.name, uid = decoded.uid;
                        settings.login = true;
                        settings.email = email;
                        settings.name = name;
                        settings.uid = uid;
                        var setTokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign({
                            email: email,
                            name: name,
                            uid: uid
                        }, "sdkjkdlsAESRcdslkch", {
                            expiresIn: "1d"
                        });
                        window.localStorage.setItem("aisoToken", setTokenValue);
                        if (router && router.asPath === "/") {
                            router.push("/user/market");
                        } else {
                            router.push(router.asPath);
                        }
                    }
                });
            }
            return [
                2
            ];
        });
    });
    return function PageTokenCheck(settings, router) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 29988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38799);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64436);
/** @format */ 









var TextMaskCustom = function(props) {
    var inputRef = props.inputRef, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_mask__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
        ref: function(ref) {
            inputRef(ref ? ref.inputElement : null);
        },
        mask: [
            /[0-9]/,
            /\d/,
            /\d/,
            " ",
            " ",
            "-",
            " ",
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            " ",
            "-",
            " ",
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ],
        placeholderChar: " ",
        showMask: true
    }));
};
TextMaskCustom.propTypes = {
    inputRef: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
var FormattedInputs = function(param) {
    var myPhone = param.myPhone, setMyPhone = param.setMyPhone;
    var handleChange = function(event) {
        /** 공백, - 표시 제거 */ var value = event.target.value.replace(/(\s*)/g, "").replace(/(\-)/g, "");
        setMyPhone(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "w-full my-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    htmlFor: "formatted-text-mask-input",
                    children: "전화번호"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    value: myPhone,
                    onChange: handleChange,
                    name: "textmask",
                    id: "formatted-text-mask-input",
                    inputComponent: TextMaskCustom
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FormattedInputs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34619,52387,94924,33426,74849,67820,49774,92888,40179], function() { return __webpack_exec__(78573); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);